import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Restricts a text input to a Sri Lankan phone number as the user types:
 * strips any non-digit characters and caps the length at 10 digits.
 *
 * Works with both reactive forms (updates the bound NgControl) and plain inputs.
 * Pair with `CustomValidators.phone()` for the validation rule (10 digits, leading 0).
 */
@Directive({
  selector: '[appPhoneInput]',
  standalone: true,
})
export class PhoneInputDirective {
  constructor(
    private elementRef: ElementRef<HTMLInputElement>,
    @Optional() private ngControl: NgControl | null,
  ) {}

  @HostListener('input')
  @HostListener('paste')
  onInput(): void {
    // Defer so pasted content is present in the input value before cleaning.
    setTimeout(() => this.clean());
  }

  private clean(): void {
    const input = this.elementRef.nativeElement;
    const cleaned = (input.value ?? '').replace(/\D/g, '').slice(0, 10);

    if (cleaned !== input.value) {
      input.value = cleaned;
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(cleaned, { emitEvent: false });
      }
    }
  }
}
